module.exports = new __parcel__URL__("background_world.40463555.png").toString();